import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6;
import { fontSize, lineHeight } from "../../constants/typography";
import { BREAKPOINTS } from "../../constants/breakpoints";
import mediaQueries from "../../util/mediaqueries";
import styled from 'styled-components';
import GridContainer from "../grid-container";
import HeadlineAndText from "../headline-and-text";
import { ImageWithLazyAttributes } from "../images";
export var Container = styled(GridContainer).withConfig({
  componentId: "sc-1akyfn-0"
})(["padding:64px 0;justify-items:center;text-align:center;@media (max-width:", "px){overflow:hidden;}", ";"], BREAKPOINTS.sm - 1, mediaQueries.sm(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    padding: 96px 0;\n  "]))))));
export var StyledHeadlineAndText = styled(HeadlineAndText).withConfig({
  componentId: "sc-1akyfn-1"
})(["grid-column:1 / -1;margin:0 0 56px;", ";", ";"], mediaQueries.md(_t2 || (_t2 = _(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    margin-bottom: 56px;\n    grid-column: 2 / -2;\n  "]))))), mediaQueries.lg(_t3 || (_t3 = _(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    margin-bottom: 64px;\n  "]))))));
export var Row = styled.div.withConfig({
  componentId: "sc-1akyfn-2"
})(["grid-column:1 / -1;width:100%;row-gap:24px;", ";", ";", ";"], mediaQueries.sm(_t4 || (_t4 = _(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n  "]))))), mediaQueries.md(_t5 || (_t5 = _(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    padding: 0 64px;\n    justify-content: space-between;\n  "]))))), mediaQueries.lg(_t6 || (_t6 = _(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    grid-column: 2 / 12;\n    padding: 0;\n  "]))))));
export var LogoItem = styled.div.withConfig({
  componentId: "sc-1akyfn-3"
})(["width:", ";transform:scale(0.8);transition:transform 0.2s ease-in;"], function (_ref) {
  var logoWidth = _ref.logoWidth;
  return "".concat(logoWidth, "px");
});
export var Image = styled(ImageWithLazyAttributes).withConfig({
  componentId: "sc-1akyfn-4"
})(["height:", ";width:auto;margin:0 auto;display:block;@media (max-width:", "px){margin:0 auto;}"], function (_ref2) {
  var height = _ref2.height;
  return "".concat(height, "px");
}, BREAKPOINTS.sm - 1);
export var LogoContainer = styled.div.withConfig({
  componentId: "sc-1akyfn-5"
})(["@media (max-width:", "px){flex:0 0 33.3333%;}"], BREAKPOINTS.md - 1);
export var Name = styled.p.withConfig({
  componentId: "sc-1akyfn-6"
})(["font-style:normal;font-weight:normal;font-size:", ";line-height:", ";margin-top:11px;"], fontSize.xSmall, lineHeight.large);
export var CarouselContainer = styled.div.withConfig({
  componentId: "sc-1akyfn-7"
})(["grid-column:1 / -1;width:100%;margin-left:", ";"], function (_ref3) {
  var margin = _ref3.margin;
  return margin;
});